import { render } from "./PromocodeTab.vue?vue&type=template&id=40004820"
import script from "./PromocodeTab.vue?vue&type=script&lang=js"
export * from "./PromocodeTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__